<svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1635_2)">
    <path d="M25.8978 41.5481V21.6588L40.1976 29.8638V33.3435L25.8978 41.5481ZM7.62975 14.6563L12.1869 12.0415V35.9583L7.62975 33.3435V14.6563ZM21.268 41.1689L16.817 38.6147V9.38505L21.268 6.83113V41.1689ZM40.1976 24.551L25.8978 16.3461V6.45166L40.1976 14.6563V24.551ZM23.9137 0.000142105L3 12.0001V35.9997L23.9137 48.0002L44.8274 35.9997V12.0001L23.9137 0.000142105Z" fill="currentColor"/>
  </g>
  <defs>
    <clipPath id="clip0_1635_2">
      <rect width="42" height="48" fill="white" transform="translate(3)"/>
    </clipPath>
  </defs>
</svg>
